// extracted by mini-css-extract-plugin
export default {"container":"ViewApplicationPage_container__c+pU8"};